import { IconButton as MuiIconButton } from '@mui/material'
import type { MouseEvent } from 'react'

export interface IconButtonProps {
  children: JSX.Element
  size?: 'small' | 'medium' | 'large'
  edge?: 'start' | 'end'
  disabled?: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  'data-testid'?: string
  ariaLabel?: string
}

export const IconButton = ({
  size = 'large',
  children,
  disabled = false,
  edge,
  onClick,
  'data-testid': dataTestId,
  ariaLabel,
}: IconButtonProps) => {
  return (
    <MuiIconButton
      onClick={onClick}
      size={size}
      disabled={disabled}
      edge={edge}
      data-testid={dataTestId}
      aria-label={ariaLabel}
    >
      {children}
    </MuiIconButton>
  )
}
